// extracted by mini-css-extract-plugin
module.exports = {"main":"Routing__main--2ebWB"};